import previewPage from './previewpage.json';
import { Page } from '../Site/Page'

export class Template {
    static previewPage: Page = previewPage as Page;
}